
import React, { Component}  from 'react';
import styled from 'styled-components';
import {Button} from "@material-ui/core";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { SequenceDisplay } from 'core/Display';
import DetailCopyToClipboardButton from "./DetailCopyToClipboardButton";
import DetailCopyToClientClipboardButton from './DetailCopyToClientClipboardButton';
import DetailScheduleForm from "../Parts/DetailScheduleForm";
import CopyText from "common/CopyText";


const StyledOrderDetailInfo = styled.div`
  
  margin-top: 30px;

  .row-1 {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 10px;
    margin-bottom: 20px;
    
    .status-payment {
      font-weight: bold;
      
      &.NOT_PAID {
        color: #EB5757;
      }
    }
    
    .tariff {
      font-weight: bold;
      margin-bottom: 5px;
    }
  }
  
  .row-2 {
    margin-bottom: 20px;
    
    .label {
      font-size: 12px;
      color: #828282;
      margin-bottom: 5px;
    }
  }
  
  .row-2-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
    
    .label {
      font-size: 12px;
      color: #828282;
      margin-bottom: 5px;
    }
  }
  
  .row-3 {
    display: grid;
    grid-template-columns: 1fr 1fr 30px;
    grid-gap: 15px;
    
    .label {
      font-size: 12px;
      color: #828282;
      margin-bottom: 5px;
    }
  }
`;


export default class OrderDetailInfo extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    }
  }

  toggleIsOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render() {
    const { detailContext, order } = this.props;
    const { isOpen } = this.state;

    return (
      <StyledOrderDetailInfo>
        <div className={'row-1'}>
          <div>
            <div className={'tariff'}>
              {!order.tariff && 'Тариф не указан'}
              {order.tariff && `Тариф ${order.tariff.name}`}
            </div>
            <div>
              <SequenceDisplay values={[
                order.container_number,
                order.container_type_display,
                order.container_owner_display
              ]} separator={', '} />
            </div>
          </div>
          <div>
            <span className={`status-payment`}>
              {order.order_payment_status_display}
            </span>
          </div>
        </div>

        {order.client && (
          <div className={'row-2'}>
            <div className={'label'}>Клиент</div>
            <div>{order.client.name }</div>
            {order.counterparty && (
              <div className={'mt-7'}>
                {order.counterparty.name}
                {order.counterparty.inn && (
                  <React.Fragment>, ИНН {order.counterparty.inn}</React.Fragment>
                )}
              </div>
            )}

            {isOpen && (
              <>
                {order.contact_persons.map(contact_person =>
                  <React.Fragment key={contact_person.id}>
                    <div className={'mt-7'}>
                      {contact_person.name}
                      {contact_person.phone && (
                        <span>, {contact_person.phone}</span>
                      )}
                    </div>

                    {contact_person.email && (
                      <div className={'mt-5'}>
                        <a href={`mailto:${contact_person.email}`} className={'email'}>{contact_person.email}</a>
                      </div>
                    )}

                    {contact_person.emails.map((email, index) =>
                      <div className={'mt-5'} key={index}>
                        <a href={`mailto:${email}`} className={'email'}>{email}</a>
                      </div>
                    )}
                  </React.Fragment>
                )}
              </>
            )}

            <div className={'mt-10'}>
              <Button
                onClick={() => this.toggleIsOpen()}
                startIcon={isOpen ? <VisibilityOffIcon /> : <VisibilityIcon />}
                size={'small'}
                variant={'outlined'}
              >
                {isOpen ? 'Скрыть контактные лица' : `Показать контактные лица (${order.contact_persons.length})`}
              </Button>
            </div>

          </div>
        )}

        <div className={'mt-10 mb-20'}>
          <DetailCopyToClientClipboardButton order={order} />
        </div>

        <div className={'row-2-2'}>
          <div>
            <div className={'label'}>Перевозчик</div>
            <div>{order.carrier_display ? order.carrier_display : 'Не указан'}</div>
          </div>
          <div>
            <div className={'label'}>Водитель</div>
            <div>
              <div>{order.driver ? <CopyText text={order.driver.full_name}>{order.driver.short_name}</CopyText> : 'Не указан'}</div>
            </div>
          </div>
          <div>
            <div className={'label'}>Транспорт</div>
            <div>{order.tractor_unit ? <CopyText text={order.tractor_unit.number} /> : 'Не указан'}</div>
          </div>
          <div>
            <div className={'label'}>Полуприцеп</div>
            <div>{order.semi_trailer ? <CopyText text={order.semi_trailer.number} /> : 'Не указан'}</div>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            <DetailCopyToClipboardButton order={order} />
          </div>
        </div>

        <div className={'mt-10'}>
          <DetailScheduleForm detailContext={detailContext} />
        </div>

      </StyledOrderDetailInfo>
    )
  }
}
